import initFixedAvatar from './fixedAvatar'
import initDetail from './detail'
import initAgreement from './agreement'
import createHttp from '../../../../../frontend-lib/tools/axios.js'
import {
  getPlatform,
  getEnvHost
} from '../../../../..//frontend-lib/tools/getPlatform.js'
import Bridge from '../../../../../frontend-lib/lib/Bridge'
const http = createHttp()
const prefix = getEnvHost('//m.xinli001.com/')

const openWebView = options => {
  const { isYixinliApp } = getPlatform()
  const isApp = isYixinliApp

  options = {
    isCurrentPageOpen: 0,
    ...options
  }

  if (isApp) {
    const myBridge = new Bridge()
    myBridge.call('openWebView', options)
  } else {
    window.location.href = options.url
  }
}
let createOrderLoading = false
// 创建与咨询订单
const createOrder = store => {
  if (createOrderLoading) return
  createOrderLoading = true
  const { teacherList, showIndex, lesson_id, keshi_id } = store
  const item = teacherList[showIndex % teacherList.length]

  const params = {
    to_user_id: item.user_id, // 老师id
    zx_num: 1,
    activity_id: 41, // 预咨询
    waytype: 'voice',

    channel_flag: 'kcbofangdaoliu',

    lesson_id, // 课程id
    keshi_id, // 课时id
    coupon_id: store.coupon_id,
    user_coupon_id: store.couponData && store.couponData.id
  }

  http
    .post(`${prefix}consult_order/create_order`, params)
    .then(res => {
      let { code, data, message } = res.data
      if (code === 0) {
        // 请求成功
        const urls = data.url.split('/')
        const orderid = urls[urls.length - 1].replace('payparam-', '')
        // from=lessonPlay：避开支付的再次协议确认
        openWebView({
          url: getEnvHost(
            `https://static.xinli001.com/msite/index.html#/consult-pay?id=${orderid}&from=lessonPlay`
          )
        })
      } else if (code === 40001) {
        window.toast(message, 2000, () => {
          const { isYixinliApp } = getPlatform()
          if (isYixinliApp) {
            window.location.href = 'yixinli://open_user_login'
          } else {
            window.location.href = `${prefix}/account/login?next=${encodeURIComponent(
              window.location.href
            )}`
          }
        })
      } else if (code === 30005) {
        // 订单待支付
        window.toast(message, 2000, () => {
          openWebView({
            url: getEnvHost(
              'https://static.xinli001.com/msite/index.html#/consult-list-user'
            )
          })
        })
      } else if (code === 30006 && message === '活动参与次数已达上限') {
        message = '您已下过预咨询订单，可做正式咨询了'

        window.toast(message, 2000, () => {
          openWebView({
            url: getEnvHost(
              `https://m.xinli001.com/consult/${item.user_id}.html?channel_flag=kcbofangdaoliu&lesson_id=${store.lesson_id}&keshi_id=${store.keshi_id}`
            )
          })
        })
      } else {
        window.toast(message, 2000)
      }
    })
    .finally(() => (createOrderLoading = false))
}
const changeTeacher = (store, avatar) => {
  store.showIndex++
  store.showDetail()
  avatar.update()
}
/**
 * lesson_id,
 * keshi_id
 * onDetailShow
 * onDetailHide
 */
export default async options => {
  options = Object.assign(
    {
      onDetailShow: () => {},
      onDetailHide: () => {}
    },
    options
  )
  try {
    const res = await http.get(`${prefix}consult/teacher-lesson-list`, {
      params: {
        lesson_id: options.lesson_id,
        keshi_id: options.keshi_id
      }
    })

    const { code, data } = res.data

    if (code !== 0 || !data.length) return

    const store = {
      teacherList: data.sort(() => 0.5 - Math.random()), // 打乱老师数组,
      showIndex: 0,
      isShowTips: true,
      isScrolling: false,

      lesson_id: options.lesson_id,
      keshi_id: options.keshi_id,

      coupon_id: 1424,
      couponData: null, // 优惠券数据

      showDetail() {
        const { teacherList, showIndex } = store
        const teacher = teacherList[showIndex % teacherList.length]

        typeof options.onDetailShow === 'function' &&
          options.onDetailShow(teacher)

        if (teacher.diversion_type === 'pre_communication') {
          // 预咨询
          detail.show()
          clearInterval(timer)
          // 协议蓝字绑定统一协议
          document
            .querySelector('.lesson-play-consult-model-treaty')
            .addEventListener('click', agreement.show)
        } else if (teacher.diversion_type === 'category_diversion') {
          // 课程分类
          openWebView({
            url: teacher.url
          })
        } else {
          // 常规咨询-rottine_consult
          openWebView({
            url: getEnvHost(
              `https://m.xinli001.com/consult/${teacher.user_id}.html?channel_flag=kcbofangdaoliu&lesson_id=${options.lesson_id}&keshi_id=${options.keshi_id}&hideNavigationBar=1`
            )
          })
        }
      },
      onDetailHide() {
        timer = setChangeTeacherTimer()

        typeof options.onDetailHide === 'function' && options.onDetailHide()
      },

      tipsClose() {
        store.isShowTips = false
        avatar.update()
      },
      onBodyScroll(state) {
        if (state) {
          store.isScrolling = state
          avatar.update()
        }

        clearTimeout(this.scrollTimer)
        this.scrollTimer = setTimeout(() => {
          store.isScrolling = state
          avatar.update()
        }, 300)
      },

      createOrder() {
        if (document.getElementById('checkZixun').checked) {
          createOrder(store)
        } else {
          agreement.show()
        }
      },
      changeTeacher() {
        changeTeacher(store, avatar)
      },
      agree() {
        createOrder(store)
      }
    }

    // 切换咨询师定时器，打开弹窗的时候暂停
    const setChangeTeacherTimer = () =>
      store.teacherList.length > 1 &&
      setInterval(() => {
        store.showIndex++
        avatar.update()
      }, 6 * 1000)

    let timer = setChangeTeacherTimer()
    let detail, agreement
    const avatar = initFixedAvatar(store, function(data) {
      store.couponData = data
      detail = initDetail(store)
      agreement = initAgreement(store) // 为了生成dom的顺序，不被挡住
    })

    return store
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/components/consult/index.js